// extracted by mini-css-extract-plugin
module.exports = {"marginBottom":"FpxModal_marginBottom__1MhfI","checkbox":"FpxModal_checkbox__1cm7B","amount":"FpxModal_amount__yqqo7"};